<template>
  <div class="form-inline">
    <input type="url" class="form-control " placeholder="" v-model="value"><a class="btn btn-primary" @click="preview()" style="color:white"><i class="far fa-eye"></i>  </a>
    <youtube :video-id="videoId" player-width="100%" v-if="showPreview"></youtube>
  </div>
</template>

<script>
/**
 <MyInputVideo v-model="item.url"></MyInputVideo>
 **/
import { getIdFromURL } from 'vue-youtube-embed'


export default {
  // name: "MyColorPicker",
  props: ["value"],
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      propsValue: this.value,
      showPreview: false,
      videoId:"",
    };
  },
  watch: {
    propsValue(newVal) {
      this.videoId = getIdFromURL(newVal)
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.videoId = getIdFromURL(newVal)
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    preview() {
      this.showPreview = !this.showPreview;
    },

  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
